import * as React from 'react'

import { Grid } from '@factorialco/deprecated-design-system'
import {
  PerformanceReviewEvaluationStatusEnum,
  PerformanceReviewEvaluationsQuery,
} from 'generated/resources/graphql'
import { sortBy } from 'lodash'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import { Celebration } from 'modules/performance_process/components/common/Celebration'
import { EvaluationCard } from 'modules/performance_process/components/common/EvaluationCard'
import { SectionWithStatus } from 'modules/performance_process/components/common/SectionWithStatus'
import { tagColor, tagLabel } from 'modules/performance_process/lib/answerTag'

export const EvaluationGrid: React.FC<{
  evaluations: PerformanceReviewEvaluationsQuery['performance']['pendingEvaluations']
  status: PerformanceReviewEvaluationStatusEnum
  reviewId: number
  celebrate?: boolean
  currentAccessId: number
}> = ({ evaluations, status, reviewId, currentAccessId, celebrate = false }) => {
  const { navigation } = useNavigation()

  if (evaluations.length === 0 && (status !== 'pending' || !celebrate)) {
    return null
  }

  return (
    <SectionWithStatus
      tagColor={tagColor(status)}
      tagLabel={tagLabel(status)}
      count={evaluations.length}
    >
      {evaluations.length === 0 && 'pending' && (
        <Celebration
          title={i18n.t('performance_process.reviews.celebration.great_job')}
          description={i18n.t('performance_process.reviews.celebration.no_pending_reviews')}
        />
      )}
      <Grid>
        {sortBy(evaluations, (evaluation) =>
          evaluation?.targetAccess?.id === currentAccessId ? -1 : 0
        ).map((evaluation) => (
          <EvaluationCard
            evaluation={evaluation}
            showTag={false}
            key={evaluation.id}
            isYou={currentAccessId === evaluation?.targetAccess?.id}
            to={navigation.performanceProcess.reviews.review.completedReviews.fullPath({
              reviewId,
              evaluationId: evaluation.id,
            })}
          />
        ))}
      </Grid>
    </SectionWithStatus>
  )
}
